/**
 * Native shell bootstrap — safe no-op in browser.
 */

import { isNativeMobileApp, navigateToDeepLinkPath } from './passportMobilePlatform';

let deepLinksBound = false;

async function bindDeepLinkListeners(): Promise<void> {
  if (!isNativeMobileApp() || deepLinksBound) return;
  deepLinksBound = true;
  const { App } = await import('@capacitor/app');
  await App.addListener('appUrlOpen', (event) => {
    try {
      const url = new URL(event.url);
      const path = url.pathname + url.search;
      if (path.startsWith('/')) navigateToDeepLinkPath(path);
    } catch {
      /* ignore malformed */
    }
  });
}

async function configureNativeChrome(): Promise<void> {
  if (!isNativeMobileApp()) return;
  try {
    const { SystemBars, SystemBarsStyle } = await import('@capacitor/core');
    await SystemBars.show();
    // Light background + dark status bar icons (Cap 8 edge-to-edge; no setBackgroundColor on Android 15+).
    await SystemBars.setStyle({ style: SystemBarsStyle.Light });
  } catch {
    /* optional plugin */
  }
}

/** Call once after loadPassportConfig — does not request notification permission. */
export async function initPassportMobileShell(): Promise<void> {
  if (!isNativeMobileApp()) return;
  document.documentElement.classList.add('passport-native-html');
  await configureNativeChrome();
  await bindDeepLinkListeners();
}
